'use es6';

import { combineReducers } from 'redux';
import Actions from 'AdsUI/lib/Actions';
import { List } from 'immutable';
import EventRecord from 'AdsUI/records/events/EventRecord';
import EventsPanelStateRecord from 'AdsUI/records/events/EventsPanelStateRecord';

const panelState = (state = EventsPanelStateRecord(), action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.OPEN_EVENT_PANEL:
      {
        return state.set('panelOpen', true);
      }

    case Actions.REPLACE_EVENT:
      {
        return state.set('panelOpen', true).set('eventToReplace', payload.eventToReplace);
      }

    case Actions.CLOSE_EVENT_PANEL:
      {
        return EventsPanelStateRecord();
      }

    default:
      {
        return state;
      }
  }
};

const list = (state = List(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.EVENTS_FETCH_SUCCEEDED:
      {
        return List(payload.map(event => new EventRecord(event)));
      }

    case Actions.EVENT_UPDATE_START:
      {
        // Update optimistically
        const {
          eventId,
          enabled
        } = payload;
        const index = state.findIndex(e => e.id === eventId);
        return state.updateIn([index], event => event.set('enabled', enabled));
      }

    case Actions.EVENT_UPDATE_FAILED:
      {
        // Revert the optimistic update
        const {
          eventId,
          enabled
        } = payload;
        const index = state.findIndex(e => e.id === eventId);
        return state.updateIn([index], event => event.set('enabled', !enabled));
      }

    case Actions.EVENT_DELETE_START:
      {
        const {
          eventId
        } = payload;
        const index = state.findIndex(e => e.id === eventId);
        return state.updateIn([index], event => event.set('deleted', true));
      }

    case Actions.EVENT_DELETE_SUCCEEDED:
      {
        const {
          eventId
        } = payload;
        return state.filter(event => event.id !== eventId);
      }

    case Actions.EVENT_DELETE_FAILED:
      {
        const {
          eventId
        } = payload;
        const index = state.findIndex(e => e.id === eventId);
        return state.updateIn([index], event => event.set('deleted', false));
      }

    default:
      return state;
  }
};

const pixelPageViewEvents = (state = 0, action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.PIXELS_EVENT_COUNT_FETCH_SUCCEEDED:
      {
        const eventCount = (payload.results || payload).filter(pixel => pixel.sendConversionEvents).length;
        return eventCount;
      }

    default:
      return state;
  }
};

export default combineReducers({
  list,
  panelState,
  pixelPageViewEvents
});